import { auth } from '@webclient/lib/agent';

import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

type Params = {
  onSuccess?: (
    data: AxiosResponse<unknown, any>,
    variables: void,
    context: unknown,
  ) => Promise<unknown> | unknown;
  onError?: (
    error: Error,
    variables: void,
    context: unknown,
  ) => Promise<unknown> | unknown;
};

export default function useDeleteUser({ onSuccess, onError }: Params) {
  return useMutation({
    mutationKey: ['delete-account'],
    mutationFn: async () => {
      return await auth.deleteMe();
    },
    onSuccess,
    onError,
  });
}
